const messages = {
  en: {
    translations: {
      all: "All",
      code: "Code",
      analysis: "GDS Analysis",
      analysis_status: "Analysis Status",
      selected_analysis: "Selected analysis",
      selected_analyzes: "Selected analyzes",
      selected_bom: "Selected BOM",
      selected_boms: "Selected BOMs",
      all_successfully_deleted: "All analyses successfully deleted!",
      customer: "Customer",
      customers: "Customers",
      bom: "BOM",
      boms: "BOMs",
      processing_import: "Processing",
      components: "Components",
      po_number: "PO Number",
      supplier: "Supplier",
      manufacturers: "Manufacturers",
      status_updated: "Status updated",
      purchase_orders: "Purchase orders",
      upcoming_deliveries: "Upcoming Deliveries",
      see_all: "See all",
      no_upcoming_deliveries: "No upcoming deliveries found.",
      upcoming_deliveries_error: "Unable to load upcoming deliveries.",
      on_hand: "OnHand",
      action: "Action",
      forecast: "Forecast",
      forecast_type: "Forecast type",
      forecast_flex_dsi_description: "The current input. Basis for MRP and shortage analysis.",
      forecast_net_description: "Pure customer demand. It does not run shortage analysis; it feeds the Material Status Net rows and simulation.",
      forecast_customer_required: "Register or select a customer to import the forecast.",
      selected_forecast: "Selected forecast",
      selected_forecasts: "Selected forecasts",
      forecast_successfully_deleted: "Forecast successfully deleted!",
      has_analysis: "Has analysis",
      analysis_has_child_warning:
        "By excluding this analysis, the simulated analyses will also be excluded.",
      purchase_order: "Purchase order",
      po: "PO",
      is_final_product: "Final Product?",
      is_in_test: "In Test?",
      importation: "Importation",
      description: "Description",
      search: "Search",
      active: "Active",
      created_at: "Created at",
      modified_at: "Updated at",
      imported_at: "Import date",
      actions: "Actions",
      cancel: "Cancel",
      save: "Save",
      sector: "Sector",
      production_line: "Production Line",
      automatic_phase: "Automatic Phase",
      phase: "Phase",
      machine: "Machine",
      process: "Process",
      new: "New",
      cost_center: "Cost center",
      tag_code: "Tag code",
      criticality: "Criticality",
      efficiency: "efficiency",
      last_maintenance_date: "Last maintenance date",
      frequency: "Frequency",
      utilization_index: "Utilization index",
      used_calendar: "Used calendar",
      conference_property: "Conference property",
      security_interval: "Security interval",
      unlimited_resource: "Unlimited resource",
      area: "Area",
      sequence: "Sequence",
      centesimal_working_hours: "Centesimal working hours",
      saturday_working_hours: "Saturday working hours",
      sunday_working_hours: "Sunday working hours",
      period_working_hours: "Period working hours",
      period_used_hours: "Period used hours",
      yield_percentage: "Yield percentage",
      warehouse_consumption: "Warehouse consumption",
      warehouse_description: "Warehouse description",
      import_spreadsheets: "Import spreadsheets",
      integration_routines_rfc_sap: "Integration routines (RFC - SAP)",
      sap_import: "SAP Import",
      rfc_bom_data: "RFC_BOM_DATA",
      rfc_stock_po_data: "RFC_STOCK_PO_DATA",
      run_import: "Run import",
      stock_and_po_import: "Stock and Purchase Order Import",
      plant: "Plant",
      select_plant: "Select plant",
      select_date: "Select date",
      select: "Select",
      import_modal_title: "Import Stock and Purchase Order",
      stock_and_po: "Stock and Purchase Orders",
      shift: "Shift",
      initial: "Initial time",
      final: "Final time",
      start: "Start",
      product: "Product",
      unit_measurement: "Unit measurement",
      abbreviation: "Abbreviation",
      rows_per_page: "Rows per page",
      product_details: "Product details",
      item_code: "Item code",
      alternative_code: "Alternative code",
      specific_description: "Specific description",
      portuguese_description: "Portuguese description",
      english_description: "English description",
      nickname: "Nickname",
      username: "Username",
      password: "Password",
      recoverPassword: "Recover password",
      confirmPassword: "Confirm password",
      email: "Email",
      superuser: "Super User",
      product_type: "Product type",
      raw_material: "Raw material",
      finished_product: "Finished product",
      intermediate_product: "Intermediate product",
      model: "Model",
      part_number: "Part Number",
      matl_type: "Material type",
      supplier_part_number_supplier: "Supplier Part Number",
      supplier_part_number_manufacturer: "Manufacturer Part Number",
      level: "Level",
      part_number_client: "Part number client",
      manufacturer: "Manufacturer",
      expiration_date: "Expiration date",
      gross_weight: "Gross weight",
      revision: "Revision",
      last_revision: "Last revision",
      minimum_grade: "Minimum grade",
      division: "Division",
      inventory_frequency: "Inventory frequency",
      base_quantity_structure: "Base quantity structure",
      decimal_places_production_order: "Decimal places production order",
      normal_treatment_without_decimals: "Normal treatment without decimals",
      round: "Round",
      increments: "Increments",
      truncate_decimal_places: "Truncate decimal places",
      model_car: "Model car",
      direct_or_indirect_appropriation: "Direct or indirect appropriation",
      direct: "Direct",
      indirect: "Indirect",
      optional_default_group: "Optional default group",
      truncate_or_round: "Truncate or round",
      truncate: "Truncate",
      block: "Block",
      enter_mrp: "Enter MRP?",
      attend_need: "Attend need",
      notes: "Notes",
      unit_of_measurement: "Unit of measurement",
      unit_measurement_internal: "Unit measurement internal",
      unit_measurement_entry: "Unit measurement entry",
      second_unit_measurement: "Second unit measurement",
      conversion_factor: "Conversion factor",
      conversion_type: "Conversion type",
      multiplies: "Multiplies",
      divide: "Divide",
      cost_purchase: "Cost/Purchase",
      default_supplier: "Default supplier",
      store_default_supplier: "Store default supplier",
      minimum_quantity_order: "Minimum quantity oorder",
      reference_value_uss: "Reference value US$",
      sale_price: "Sale price",
      last_purchase_currency: "Last purchase currency",
      last_purchase_value: "Last purchase value",
      last_purchase: "Last purchase",
      default_cost_currency: "Default cost currency",
      default_cost: "Default cost",
      last_calculation_default_cost: "Last calculation default cost",
      fob_cost_currency: "Fob cost currency",
      fob_cost: "Fob cost",
      last_calculation_fob_cost: "Last calculation fob cost",
      delivery_time: "Delivery time",
      delivery_time_type: "Delivery time type",
      hours: "Hours",
      days: "Days",
      months: "Months",
      years: "Years",
      calculation_delivery_time_formula: "Calculation delivery time formula",
      tolerance: "Tolerance",
      stock: "Stock",
      stock_group: "Stock group",
      maximum_stock: "Maximum stock",
      security_stock: "Security stock",
      economic_lot: "Economic lot",
      minimum_lot: "Minimum lot",
      packing_quantity: "Packing quantity",
      security_stock_formula: "Security stock formula",
      default_warehouse: "Default warehouse",
      traceability: "Traceability",
      product_origin: "Product origin",
      national: "National",
      foreign_direct_import: "Foreign direct import",
      foreign_adq_domestic_market: "Foreign ADQ domestic market",
      foreign: "Foreign",
      product_traceability: "Product traceability",
      subbatch_traceability: "Subbatch traceability",
      does_not_use_traceability: "Does not use traceability",
      batch_traceability: "Batch traceability",
      default_production_map_operation: "Default production map operation",
      copy_quantity_bar_code: "Copy quantity bar code",
      bar_code: "Bar code",
      imported_product: "Imported product",
      purchased_out_state: "Purchased out state",
      family: "Family",
      ghost: "Ghost",
      controls_addressing: "Controls addressing",
      own_third_or_party: "Own third or party",
      own: "Own",
      third: "Third",
      product_base: "Product base",
      product_component: "Product component",
      loss_index: "Loss index",
      initial_validity: "Initial validity",
      final_validity: "Final validity",
      process_time: "Process time",
      quantity_type: "Quantity type",
      optional_group: "Optional group",
      item_optional_group: "Item optional group",
      initial_revision: "Initial revision",
      final_revision: "Final revision",
      product_level: "Product level",
      reverse_product_level: "Reverse product level",
      lot_potency: "Lot potency",
      warehouse: "Warehouse",
      quantity: "Quantity",
      alternative_use: "Alternative use",
      file_imported: "File imported",
      import_file: "Import file",
      import: "Import",
      user: "User",
      name: "Name",
      legacy_code: "Legacy code",
      group: "Group",
      menu: "Menu",
      visible: "Visible",
      permission: "Permission",
      successfully_updated: "Successfully updated",
      successfully_registered: "Successfully registered",
      successfully_deleted: "Successfully deleted",
      successfully_uploaded: "Successfully uploaded",
      successfully_reset: "Successfully reset",
      import_started_successfully: "Import started successfully",
      required_field: "The field is required",
      must_be_a_integer_number: "must be a integer number",
      must_be_a_number: "must be a number",
      unique_validation_failure: "unique validation failure",
      must_be_a_positive_number: "must be a positive number",
      invoice_no_date_error: "Invoice cannot be saved without a date",
      cannot_insert_update_duplicate_key: "Cannot insert or update duplicate key",
      fixed: "Fixed",
      variable: "Variable",
      invalid_time_format: "Invalid time format",
      invalid_date_format: "Invalid date format",
      invalid_number_format: "Invalid number format",
      default_moment_locale: "en-in",
      token_error_redirecting: "Token error. Redirecting...",
      of: "of",
      basic_inputs: "Basic inputs",
      product_process: " Product - Process",
      invalid_file: "Invalid file",
      enter: "Enter",
      welcome_home: "Welcome to",
      home: "Home",
      not_found: "Page not found",
      hub_url_unavailable_message: "Couldn't find the Access Hub. Ask an administrator to configure the Hub URL, or try the local emergency login below, if available.",
      invalid_credentials: "Unable to log in with the provided credentials.",
      exceeds_character_limit: "Exceeded character limit.",
      logout: "Logout",
      session_expired: "Your session has expired.",
      session_expired_title: "Session expired",
      session_expired_message: "Your session has expired. Log in again to continue where you left off.",
      login_again: "Log in again",
      hub_unavailable_message: "The Access Hub is currently unavailable.",
      retry: "Retry",
      local_fallback_login_link: "Sign in with local emergency credentials",
      local_fallback_login_title: "Local emergency login",
      local_fallback_login_description: "Use your local PlanMat credentials while the Access Hub is unavailable.",
      local_fallback_login_unavailable: "Local emergency login is not available right now.",
      confirm: "Confirm",
      edit: "Edit",
      delete: "Delete",
      exclude_bom: "Exclude BOM",
      save_form: "Save",
      superUser: "Administrator",
      confirm_delete: "Are you sure you want to delete this item?",
      confirm_delete_itens: "Are you sure you want to delete the selected items?",
      password_not_match: "The passwords do not match.",
      product_line: "Product line",
      planning: "Planning",
      simulation: "Simulation",
      is_active: "Active",
      is_superuser: "Superuser",
      module: "Module",
      root_description: "Module",
      empty_listing: "No records found.",
      no_shift: "No shifts found.",
      new_password: "New password",
      confirm_new_password: "Confirm new password",
      undefined: "Undefined",
      security: "Security",
      status: "Status",
      inactive: "Inactive",
      codename: "Code",
      redefine_password: "Redefine password",
      identity_managed_by_hub: "Username, name and email come from the Access Hub and are read-only here.",
      edit_at_access_hub: "Edit at Access Hub",
      user_creation_not_available: "Users are created automatically on first login through the Access Hub.",
      grant_permission: "Grant all permissions.",
      deny_permission: "Deny all permissions.",
      codename_or_name: "Name / Code",
      error_user_selected: "Select a user to add the permission.",
      history: "History",
      history_update: "Updated",
      history_create: "Created",
      history_delete: "Deleted",
      is_staff: "Is staff",
      is_default: "Is default",
      true: "Yes",
      false: "No",
      modified_to: "modified to",
      general: "General",
      type_process: "Type process",
      hybrid: "Hybrid",
      available_production_line: "Available for production line:",
      used_production_line: "Used on the production line:",
      info_ordination: "Drag items to sort them.",
      segment: "Product Segment",
      station: "Station",
      programmed: "Programmed Shutdown",
      unscheduled_stop: "Unscheduled stop",
      confirm_type_process: "Confirm change.",
      confirm_type_process_text:
        "This production line has an associated station, do you really want to change the type of process? Associations will be lost.",
      programmed_shutdown: "Programmed Shutdown",
      duration: "Duration",
      type: "Type",
      commercial: "Part Number Commercial",
      name_or_commercial: "Commercial Part Number or Product",
      start_validity: "Validity start",
      end_validity: "Validity end",
      search_name: "Search name",
      search_programmed: "Search programmed",
      validity_start_date: "Validity start date",
      validity_end_date: "Validity end date",
      start_time: "Start time",
      end_time: "End time",
      error_required_field: "Make sure all required fields are filled in.",
      invalid_group: "A group with this name already exists.",
      the_record_already_exists: "The record already exists",
      replanning_reason: "Replanning Reason",
      reason: "Reason",
      cause: "Default Cause",
      yes: "Yes",
      no: "No",
      loading: "Loading",
      invalid_format: "Invalid format",
      order: "Order",
      search_shift: "Search shift",
      workday: "Workday",
      length: "Duration",
      error_programmed_selected: "Select a programmed shutdown to associate with the shift.",
      module_options: "What do you want to do?",
      production_capacity: "Production capacity",
      basic: "Basic",
      reports: "Reports",
      settings: "Settings",
      access_control: "Access control",
      invalid_email: "You must enter a valid email.",
      registrations: "Registrations",
      demand: "Demand",
      production_planning: "Production Planning",
      replanning_history: "Replanning history",
      smt_default_time: "Default SMT time",
      manual_default_time: "Manual default time",
      scheduled_stop: "Scheduled stops",
      reason_replanning: "Replanning reason",
      production_ramp: "Production ramp",
      calendar_event_type: "Calendar event type",
      calendar: "Calendar",
      marker: "Bookmark",
      reason_replanning_report: "Replanning reasons",
      production_line_usage: "Usage of production lines",
      realized_vs_planned: "Realized vs planned",
      preferences: "Preferences",
      expression_builder: "Expression Builder",
      headcount: "Number of people",
      stops: "Stops",
      line_configuration: "Line configuration",
      default: "Default",
      color: "Color",
      search_description: "Search description",
      useful_day: "Useful day",
      day_off: "Day off",
      pn_commercial: "PN Comercial",
      is_top_bottom: "Top-Bottom",
      component: "Component",
      sides: "Sides",
      add: "To add",
      production_ramp_settings: "Production ramp settings",
      npi: "NPI",
      side: "Side",
      version: "Version",
      versions: "System versions",
      production_order: "Production order",
      reference_date: "Reference date",
      font_color: "Font color",
      production_order_peripheral: "Production order peripherals",
      lines: "Lines",
      production_ramp_day: "Day ",
      validate_production_lines: "Production lines must contain the same settings",
      duplicate: "Duplicate",
      default_time_seconds: "Standard time",
      people_quantity: "People quantity",
      capacity: "Capacity",
      default_expression: "Default expression:",
      expression: "Expression",
      initial_date: "Initial date",
      final_date: "Final date",
      available: "Available",
      planned: "Planned",
      in_production: "In production",
      finished: "Finished",
      january: "January",
      february: "February",
      march: "March",
      april: "April",
      may: "May",
      june: "June",
      july: "July",
      august: "August",
      september: "September",
      october: "October",
      november: "November",
      december: "December",
      message_home: "Plan-Mat is a material purchase planning system.",
      save_plus: "Save +",
      close: "Close",
      clear: "Clear",
      open: "Open",
      month: "Month",
      year: "Year",
      event: "Event",
      start_date: "Start date",
      end_date: "End date",
      validate_end_time: "This time must be longer",
      validate_event_create: "It is only allowed to create an event after the current date",
      available_time: "Available time",
      return_value: "Return value",
      default_time: "Default time",
      assemble_expression: "Assemble the expression",
      set_default_expression: "Set as default expression",
      AVAILABLE_TIME: "AVAILABLE TIME",
      DEFAULT_TIME: "DEFAULT TIME",
      PEOPLE_QUANTITY: "PEOPLE QUANTITY",
      CAPACITY: "VOLUME",
      volume: "Volume",
      day: "Day",
      line: "Line",
      duplicate_version: "Duplicate version",
      delete_version: "Delete version",
      change_final_version: "Change to final version",
      duplicate_version_successfully: "Duplicate version successfully",
      confirm_make_version_final: "Do you really want to make version ($description) final?",
      to_plan: "To plan",
      sunday: "Sunday",
      monday: "Monday",
      tuesday: "Tuesday",
      wednesday: "Wednesday",
      thursday: "Thursday",
      friday: "Friday",
      saturday: "Saturday",
      new_marker: "New marker",
      peripheral: "Peripheral",
      interrupt_demand: "Interrupt demand",
      markers: "Markers",
      remove_planning_message: "Want to remove the planning?",
      can_not_edit_planning_with_final_version:
        "You cannot make a change to a production version. Change a duplicate version and then publish",
      production_line_top: "Production line TOP",
      production_line_bot: "Production line BOTTON",
      demand_total: "Demand total",
      shift_to_start: "Shift to start",
      line_setup_stop: "Line setup stop",
      different_line: "Phases A and B in different lines",
      shifts: "Shifts",
      production_line_backend: "Backend production line",
      associate_shift: "Associate shift",
      no_associated_shift: "No associated shift",
      value_day_one: "Value day 1",
      value_day_two: "Value day 2",
      value_day_three: "Value day 3",
      value_day_four: "Value day 4",
      value_day_five: "Value day 5",
      value_day_six: "Value day 6",
      value_day_seven: "Value day 7",
      production_line_required: "Select at least one production line",
      info_demand: "Demand information",
      edit_demand: "Demand edit",
      history_month: "Monthly history",
      balance: "Balance",
      planned_quantity: "Planned",
      move_balance: "Move balance",
      bone_pile: "Defect",
      scrap: "Waste",
      realized: "Realized",
      finalize_demand: "Finalize demand",
      info_finalize_demand: "Do you want to finalize the demand?",
      finalize: "Finalize",
      smt_configuration: "No SMT time setting",
      manual_configuration: "No Manual time setting",
      unknown_error: "Oops... there was an unexpected thing!",
      new_simulation: "New optimization",
      new_version: "New version",
      all_rights_reserved: "2025 Foxconn. All rights reserved",
      developed_by: "Developed by",
      edit_planning: "Edit planning",
      smt_warnning: "SMT time",
      manual_warnning: "Manual time",
      valid_quantity: "Quantity cannot exceed the demand value",
      anticipate_planning: "Anticipate upcoming plans",
      replanning_amount: "Replanning amount",
      date: "Date",
      must_be_bigger_equal_than_start_date: "Must be bigger or equal than start date",
      must_be_less_equal_than_final_date: "Must be less or equal than final date",
      must_be_bigger_than_start_date: "Must be bigger than start date",
      must_be_less_than_final_date: "Must be less than final date",
      must_be_bigger_than_start_time: "Must be bigger than start time",
      must_be_less_than_final_time: "Must be less than final time",
      line_setup: "Line setup",
      no_records_found: "No records found",
      demand_used_hours: "Demand used hours",
      group_by: "Group by",
      consolidated: "Consolidated",
      detailed: "Detailed",
      import_material_transit: "Import material in transit",
      product_description: "Product description",
      delivery_date: "Delivery date",
      result: "Result",
      side_a: "Side A",
      side_b: "Side B",
      max_qtd: "Max quantity ",
      product_model: "Product model",
      title_event: "event",
      attention: "Attention",
      exists_planning:
        "There is already planning for this period, do you want to continue and replan?",
      add_delay: "Fill in to delay the start of the back-end production line.",
      delivery: "Delivery",
      planning_by_delivery: "Planning by delivery",
      no_planned: "No planned",
      input: "Input",
      create_demand: "Create demand",
      simulation_options: "Simulation options",
      max_value: "The field can't be greater than ",
      min_value: "The field can't be lesser than ",
      invalid_quantity: "Insufficient quantity to create demand",
      value: "Value",
      MAIL_HOST: "Mail host",
      MAIL_PORT: "Mail port",
      MAIL_SENDER: "Mail sender",
      MAIL_PASSWORD: "Mail password",
      MAIL_USE_TLS: "Mail use TLS",
      MAIL_USE_SSL: "Mail use SSL",
      DEMAND_DAYS_BEFORE_VALIDATE: "Days before validate demands",
      EMAILS_TO_ALERT: "E-mails to alert",
      PRODUCTION_PLAN_XLS_PATH: "Path to generate planning xls",
      notifications: "Notifications",
      verify_demand: "Verify demand",
      production_line_manual: "Manual production line",
      production_line_smt: "SMT Production line",
      next: "Next",
      previous: "Previous",
      select_demand: "Select demand",
      adjust_variables: "Adjust variables",
      define_period_and_shifts: "Set shifts and period",
      top_bottom_different_line: "Top / Bottom in different production line",
      planned_qty: "Qty. planned",
      head_count: "Head count",
      production_time: "Production time",
      ramp: "Ramp",
      input_a_value: "Input a value",
      greater_than_equal_0: "The field must be greater than or equal to 0",
      greater_than_equal_1: "The field must be greater than or equal to 1",
      less_than_equal_1000: "The field must be less than 1000",
      generate_demand: "Generate demands",
      line_setting: "Line setting",
      smt: "SMT",
      manual: "Manual",
      aligned: "Aligned",
      create: "Create",
      delete_simulation: "Clear future plannings",
      simulation_result: "Simulation result",
      sync: "Sync",
      delayed: "Delayed",
      total_simulations: "Total simulations",
      plannings_removed: "Plannings removed",
      optimization_progress: "Optimization progress",
      optimization_started: "Optimization started",
      optimization_finalized: "Optimization finalized",
      downtime_reason: "Downtime reason",
      downtime: "Downtime",
      scheduled: "Scheduled",
      unscheduled: "Unscheduled",
      downtime_ranking: "Stops ranking",
      reason_qty: "Reason quantity",
      downtime_summary_by_quantity_report: "Downtimes by time and quantity",
      downtime_summary_by_available_time_report: "Downtimes by available time",
      downtime_by_year: "Downtime by year",
      downtime_by_month: "Downtime by month",
      downtime_by_week: "Downtime by week",
      downtime_by_day: "Downtime by day",
      report_by_available_time: "Report by available time",
      time: "Time",
      report_type: "Report type",
      planned_quantity_required: "Planned quantity is required",
      capacity_required: "Capacity is required",
      import_production: "Import production",
      verify_planning: "Verify planning",
      produced_quantity: "Produced quantity",
      week: "Week",
      weeks: "Weeks",
      qty: "Quantity",
      product_name: "Product",
      segment_name: "Segment",
      realized_and_planned_by_year: "Realized vs planned by year",
      realized_and_planned_by_month: "Realized and planned bymonth",
      realized_and_planned_by_week: "Realized and planned by week",
      realized_and_planned_by_day: "Realized and planned by day",
      production_import_successful: "Production imported successfully",
      nothing_to_import: "Nothing to import",
      start_week: "Start week",
      end_week: "End week",
      must_be_bigger_equal_than_start_week: "Must be bigger equal than start week",
      select_by: "Select by",
      oee_month_goal: "OEE month goal",
      oee_year_goal: "OEE year goal",
      goal: "Goal",
      oee: "OEE",
      monthly: "Monthly",
      weekly: "Weekly",
      oee_one: "OEE1",
      monthly_oee: "Monthly OEE1",
      year_oee: "Year OEE1",
      month_target: "Year target",
      year_target: "Month target",
      dashboard: "Dashboard",
      ai_demand_forecast: "AI demand forecast",
      dashboard_oee: "Dashboard OEE",
      period: "Period",
      achieved: "Achieved",
      percentage: "Percentage",
      backlog: "Backlog",
      current_year_realized: "Current year realized",
      current_year_backlog: "Current year backlog",
      current_month_realized: "Current month realized",
      current_week_realized: "Current week realized",
      ft_test_buffer: "FTTest Buffer",
      wip_volume: "Wip Volume",
      import_line_schedule: "Import line schedule",
      serial_number: "Serial number",
      rev: "REV",
      bios_rev: "BIOS REV",
      model_name: "Model name",
      group_name: "Group name",
      next_station: "Next station",
      last_log: "Last log",
      working_time: "Working time",
      emp_no: "EMP NO",
      rota: "ROTA",
      total: "Total",
      line_schedule: "Line schedule",
      hour: "Hour",
      today: "Today",
      production_order_demand: "Demand's production orders",
      buffer_chart: "Buffer Chart",
      delivery_file: "Delivery file",
      columns: "Columns",
      released_forecast: "Released forecast",
      total_backlog: "Total Backlog",
      slc_on_hand: "SLC On-Hand (LT=0)",
      factory_on_hand: "Factory On-Hand",
      projected_inventory: "Projected inventory",
      projected_dsi: "Projected DSI",
      local_balance: "Local Inventory",
      update_with_planned: "Update with planned",
      active_line_count: "Active lines",
      active_line_shift: "Active lines by shift",
      safety_stock_ok: "Safety stock ok",
      excess_stock: "Excess stock",
      stock_on_alert: "Stock on alert",
      critical_stock: "Critical stock",
      active_people_count: "Active people",
      active_people_line: "Active people per line",
      upph: "UPPH",
      uph: "UPH",
      upph_production_line: "UPPH production line",
      send_final_version_planning: "Send final version",
      successfully_send_planning: "Planning sent successfully",
      final_version_planning: "Final version planning",
      select_an_item_below: "Select an item below",
      more_options: "More options",
      invalid_emails: "Enter valid emails separated by semicolons.",
      last_updated: "Last updated",
      next_updated: "Next updated",
      automatic: "Automatic",
      manual_or_smt: "Manual or SMT",
      urgent_planning: "Urgent planning",
      initial_quantity: "Initial quantity",
      yearly_chart: "Yearly chart",
      monthly_chart: "Monthly chart",
      weekly_chart: "Weekly chart",
      daily_chart: "Daily chart",
      info_search_reports: "The values displayed correspond to the selected period",
      bom_number: "BOM number",
      code_bom: "BOM code",
      failed_to_retrieve_customers: "Failed to retrieve the list of customers. Please try again.",
      file_must_be_selected: "You must select a file before proceeding.",
      file_uploaded_successfully_one: "File uploaded successfully!",
      file_uploaded_successfully_other: "Files uploaded successfully!",
      failed_to_upload_file: "Failed to upload the file. Please try again.",
      drag_and_drop_file: "Drag and drop an .xlsx file here or click import.",
      forecast_number: "Forecast Number",
      import_bom: "Import BOM",
      import_forecast: "Import Forecast",
      upload_file: "Import your ($type) file",
      finished_good: "Finished Good",
      creation_date: "Creation date",
      created_by: "Created by",
      waiting_analysis: "Waiting",
      processing_analysis_col: "Processing",
      finalizing_analysis: "Finalizing",
      concluded_analysis: "Concluded",
      calculation_error_analysis: "Calculation Error",
      save_error_analysis: "Save Error",
      analysis_type_analysis: "Analysis",
      simulation_type_analysis: "Simulation",
      simulation_tooltip: "Simulation of analysis Id: {{id}}",
      waiting_analysis_tooltip:
        "The analysis was requested and is in the queue to start processing.",
      processing_analysis_tooltip:
        "The analysis is calculating the results. Wait for completion before consulting details.",
      finalizing_analysis_tooltip:
        "The results have already been calculated and are being prepared for release. It is not yet possible to open details or export.",
      concluded_analysis_tooltip:
        "The analysis was processed and the results are available for consultation and export.",
      calculation_error_analysis_tooltip:
        "The analysis was not completed because a failure occurred during data processing.",
      save_error_analysis_tooltip:
        "The results were calculated, but a failure occurred while saving the data. Try processing again or contact support.",
      import_date: "Import date",
      demands_rfc: "Consider demands from",
      file_name: "File name",
      document: "Document",
      material: "Material",
      bom_component: "BOM Component",
      use_quantity: "Use quantity",
      bom_not_imported: "BOM not imported into the system.",
      create_new_analysis: "Create new analysis",
      processing: "Processing",
      fully_completed: "Fully completed",
      analysis_fully_completed_tooltip:
        "Analysis is fully completed (calculation and persistence finished)",
      analysis_not_fully_completed_tooltip: "Analysis is not fully completed yet",
      new_analysis: "New analysis",
      simulated_analysis: "Simulated analysis",
      priority: "Priority",
      select_customer: "Select a customer:",
      processs_analysis: "Process analysis",
      select_customer_error: "Select a customer to continue.",
      select_forecast: "Select a Forecast:",
      select_forecast_error: "Select a forecast to continue.",
      selected_models: "selected models",
      execute: "Execute",
      rfc_system: "The system will import the next 48 weeks starting today.",
      move_top: "Move to top",
      organize_by_priority: "Organize by priority:",
      change_priority: "Click, hold and hold list items to change priority.",
      order_button: "Drag the rows or use the buttons to change the order.",
      priority_empty: "No priority defined.",
      running_analysis: "Processing the analysis.",
      calc_available_demand: "Calculating availability and demand...",
      process_information: "You can access other system modules while you wait.",
      file_must_follow_template: "The file must follow the XLSX template standard.",
      download_template: {
        text: "Download the template ",
        link: "here.",
      },
      models: "Models",
      transit: "Transit",
      in_stock: "In stock",
      in_transit: "In transit",
      substitutes: "Replaces",
      final_products: "Models",
      unit_price: "Unit price",
      unit_price_table: "Unit Value",
      total_value_table: "Total Value",
      stock_onhand: "Stock (Onhand)",
      stock_value: "Stock value",
      balance_value: "Balance value",
      usage_quantity: "Usage qty",
      model_apportionment: "Model apportionment",
      proportional_usage_sum: "proportional to usage qty (usage sum: {{total}})",
      unit_short: "un",
      export_analysis: "Export .xlsx",
      export_filtered_analysis: "Export filtered",
      export_complete_analysis: "Export complete",
      material_status: "Material Status",
      material_status_not_generated_tooltip:
        "This analysis does not have a Material Status generated yet. Complete the GDS calculation and click Generate Material Status.",
      generate_material_status: "Generate Material Status",
      view_material_status: "View Material Status",
      open_material_status: "Open Material Status",
      material_status_generating: "Generating…",
      material_status_generation_failed: "Failed to generate",
      material_status_retry: "Try again",
      material_status_subtitle:
        "This action will freeze the current analysis data in a Material Status.",
      material_status_current_analysis: "Current analysis",
      material_status_analysis_date: "Analysis date",
      material_status_horizon: "Horizon",
      material_status_weeks: "{{count}} weeks",
      material_status_boms_included: "Included BOMs",
      material_status_available_data: "Data to be made available",
      material_status_models_boards: "Models/Boards",
      material_status_gds_items: "Items (GDS)",
      material_status_identification: "Identification and traceability",
      material_status_history_intro: "A history will be recorded with:",
      material_status_generation_date: "Generation date and time",
      material_status_responsible_user: "Responsible user",
      material_status_linked_analysis: "Linked analysis",
      material_status_models_items_quantity: "Number of models/items",
      material_status_models_items_value: "{{models}} models / {{items}} items",
      material_status_preview: "Generation preview",
      material_status_models_boards_quantity: "Number of models/boards",
      material_status_status: "Status",
      material_status_ready: "Ready to generate",
      material_status_data_unavailable: "Unavailable",
      material_status_static_notice:
        "Published data will exactly reflect the state of this analysis at the moment of generation.",
      material_status_confirm: "Confirm generation",
      material_status_analysis_unavailable:
        "Generation will be available once the analysis is fully completed.",
      material_status_integration_unavailable:
        "This analysis is not ready for generation.",
      material_status_not_ready:
        "Generation is not available for this analysis.",
      material_status_summary_error:
        "Could not load generation preview.",
      material_status_generation_error:
        "Could not generate Material Status.",
      material_status_already_generated:
        "This analysis already has a generated Material Status.",
      material_status_not_generated: "Material Status not generated",
      material_status_empty_description:
        "Generate Material Status when you want to freeze this analysis data.",
      material_status_generation_success: "Material Status generated successfully.",
      material_status_generated_metadata: "{{name}} · UUID {{uuid}}",
      material_status_generated_tooltip: "Material Status generated",
      material_status_generated_at_tooltip: "Material Status generated on {{- date}}",
      bom_model: "BOM Model",
      item: "Item",
      usage_priority: "Usage priority",
      purchase_priority: "Purchase priority",
      phantom: "Phantom",
      is_imperfect: "Imperfect",
      perfect: "Perfect",
      legend: "Legend",
      prime: "Prime",
      alternative: "Alternative",
      missing_bom_detected: "Missing BOMs detected",
      missing_bom_text:
        "There are models in this Forecast without BOMs imported into the system. Do you want to continue with the analysis?",
      proceed_regardless: "Proceed regardless",
      import_history: "Import history",
      send: "Send",
      import_file_type_not_accepted: "File type not accepted. Please use .xlsx or .xls",
      analysis_processing: "Analysis processing",
      in_processing: "In processing",
      concluded: "Concluded",
      execution_time: "Execution time",
      processing_start_time: "Date/Hour start",
      processing_end_time: "Date/Hour end",
      cancel_processing: "Cancel processing",
      download_log: "Download log",
      open_gds: "Open GDS",
      error: "Error",
      completed: "Completed",
      canceled: "Canceled",
      waiting: "Waiting",
      processing_analysis: "Processing",
      import_in_progress: "Import in progress",
      import_failed: "Import failed",
      waiting_in_queue: "Waiting in queue...",
      import_completed_reloading: "Import completed! Refreshing page...",
      processing_file: "Processing file...",
      rows: "rows",
      file_selected: "File selected",
      files_selected: "files selected",
      no_file_selected: "No file selected.",
      all_files_failed_to_import: "All files failed to import.",
      files_failed_to_import: "Failed to import {failed} out of {total} files.",
      time_remaining: "Estimated remaining time:",
      minute: "minute",
      minutes: "minutes",
      and: "and",
      download_message: "You can download the technical log for more details.",
      estimating: "Estimating",
      analysis_details: "See analysis details",
      delete_analysis: "Delete registry",
      filter: "Filter",
      apply: "Apply",
      select_all: "Select all",
      finished_goods: "Finished goods",
      subtotal: "Subtotal",
      unit: "Unit",
      estimated_time_delivery: "ETD",
      analysis_waiting_start: "Analysis waiting to start",
      analysis_waiting_in_queue: "Waiting in queue to perform analysis",
      no_notifications: "No notifications",
      unit_measure: "Unit of measure",
      total_to_go: "Total To Go",
      no_in_transit: "No item in transit.",
      cell_data_processing:
        "The detailed extract is still being saved in the system. Please wait a moment to view the complete information.",
      select_period: "Period:",
      bom_quantity: "BOM quantity",
      copy: "Copy",
      copied: "Copied",
      system_data: "System data",
      update_data: "Update data",
      manual_edit: "Manual edit",
      bom_priority: "BOM priority",
      stock_and_transit: "Stock and transit",
      edit_manually: "Edit Manually",
      duplicate_analysis: "Duplicate Analysis",
      copy_analysis: "Copy",
      simulate_gds: "Simulate GDS",
      reset: "Reset",
      reprocess_analysis: "Reprocess Analysis",
      reset_data: "Reset data",
      confirm_reset: "Are you sure you wish to reset changes?",
      original_value: "Previous value",
      original: "Original",
      invoice: "Invoice",
      invoice_search_placeholder: "Separate multiple invoices with ;",
      invoice_not_found: "Invoice not found",
      cancel_analysis_simulation: {
        discard_simulation: "Discard simulation",
        message: "Are you sure you wish to cancel the creation of this simulation?",
        description: "All changes will be lost.",
        mantain_simulation: "Maintain simulation",
        cancel_simulation: "Cancel simulation",
      },
      analysis_selector: {
        indicators_from: "Indicators from analysis:",
        select_analysis: "Select analysis",
        open_analysis: "Open this analysis",
        search_placeholder: "Search by number, description or customer",
        completed_analyses: "Completed analyses",
        most_recent: "most recent",
        empty: "No analysis found.",
      },
      coverage_indicators: "Coverage indicators",
      coverage_critical: "Critical Coverage",
      coverage_partial: "Watchlist Coverage",
      coverage_total: "Excess materials",
      items_less_coverage: "Items with up to 4 weeks of coverage.",
      items_partial_coverage: "Items with 5 to 8 weeks of coverage.",
      items_full_coverage: "Items exceeding the limit after full coverage.",
      configurations: "Configurations",
      continuous_forecasting: "Continuous forecasting and outlier detection (95% CI)",
      forecast_long_run: "Long-term forecast",
      high_demand: "High demand in the last 5 months.",
      deviations_anomalies: "Deviations/Anomalies",
      occurrences: "Cases",
      out_or_in_standard: "{{type}} consumption in the last 5 months.",
      confidence_interval: "Confidence interval",
      ic: "95% CI",
      low_high_demand: "{{type}} demand in the last 5 months.",
      low_high_trend: "{{type}} trend in the last 5 months.",
      dashboard_page: {
        ic_trust: "95% CI (Confidence Interval)",
        ic_forecast: "95% CI (Forecast)",
        history: "Consolidated forecast",
        predicted: "AI forecast prediction",
        out_of_standard: "Out of Standard",
        trend: "Trend",
        forecast: "Dell forecast prediction",
        high: "High",
        low: "Low",
        neutral: "Neutral",
        standard: "Standard",
        out_of_standard_history: "Out of standard",
      },
      expired_date: "Expired date",
      material_in_transit: "Material in transit",
      waiting_invoice: "Waiting invoice",
      delete_waiting_invoice_items: "Delete waiting invoice items",
      confirm_delete_waiting_invoice: "Do you want to remove all items with status Waiting invoice from the simulation scenario?",
      waiting_invoice_deleted_successfully: "Waiting invoice items removed successfully.",
      purchase_orders_by_status: "Purchase Orders by Status",
      orders_total_count: "{{total}} orders in total",
      orders: "orders",
      of_total: "of total",
      view_all: "View all",
      materials_demands: "Items and Demand",
      gds_result: "GDS Result",
      update_prices: "Update prices",
      updating_prices: "Updating prices...",
      price_last_updated: "Prices last updated on {{date}}",
      update_sap_prices_confirmation:
        "Do you want to start updating material and demand prices for this analysis?",
      price_update_started: "Price update started.",
      price_update_completed: "Prices updated successfully.",
      price_update_failed: "The SAP price update failed.",
      price_update_already_running: "A price update is already in progress.",
      price_update_start_failed: "The price update could not be started.",
      select_analysis_to_update_prices: "Select an analysis to update prices.",
      material_type: "Material Type",
      metrics_items_with_demand: "Items with demand",
      metrics_critical: "Critical coverage: up to 4 weeks",
      metrics_attention: "Coverage requiring attention: 5 to 8 weeks",
      metrics_stable: "Healthy coverage: over 8 weeks",
      metrics_excess: "Excess items",
      metrics_unclassified: "No valid coverage",
      coverage: "Coverage",
      excess: "In excess",
      balance_filter: "Balance",
      balance_excess: "In excess",
      balance_shortage: "Shortage",
      predicted_demand: "Predicted demand",
      coverage_low: "Critical, < 50%",
      coverage_insufficient: "Partial, 50% to 99%",
      coverage_complete: "Complete, 100%",
      coverage_critical_week: "Critical: up to 4 weeks",
      coverage_attention: "Attention: 5 to 8 weeks",
      coverage_stable: "Healthy: over 8 weeks",
      waiting_invoice_label: "Waiting Invoice",
      shortage: "Shortage",
      copy_failed: "Failed to copy",
      model_quantity: "Model quantity",
      analysis_not_found: "Analysis not found",
      invalid_api_response: "Invalid API response",
      export_already_created_downloading: "Export already created, downloading file...",
      error_downloading_file_try_again: "Error downloading file. Please try again.",
      export_error: "Export error",
      export_analysis_started: "Analysis export started",
      export_analysis_completed: "Analysis export completed",
      export_analysis_started_success: "The analysis export was started successfully.",
      export_analysis_completed_success: "The analysis export was completed successfully.",
      export_started_notification: "Export started. You will be notified when it is ready.",
      export_disabled_persistence_pending:
        "The export will be available as soon as all your data is saved. You will be notified when it is ready.",
      export_no_data_available:
        "It was not possible to export the spreadsheet. There is no data available for export. Please check the filters or perform a new analysis to generate content.",
      selected_records: "Selected records",
      selected_record: "Selected record",
      delete_import_history: "Delete import histories",
      error_fetch_data: "Error fetching data",
      error_deleting_boms: "Error deleting BOMs",
      some_boms_not_deleted: "Some BOMs were not deleted",
      boms_successfully_deleted: "BOMs deleted successfully",
      cannot_delete_bom_with_active_analysis: "Cannot delete BOMs that are part of active analyses",
      import_data: "Import data",
      select_source_data: "Select source data:",
      files_xls: "Files .xls",
      sap_data: "SAP data",
      partially_updated: "Partially Updated",
      updated: "Updated",
      operation: "Operation",
      homolog_local: "Homologation Environment",
      development_local: "Development Environment",
      reprocess_failures: "Reprocess failures",
      updated_boms: "Updated BOMs",
      failed_boms: "Failed BOMs",
      rfc: "RFC",
      parameters: "Parameters",
      start_datetime: "Start date/time",
      end_datetime: "End date/time",
      execution_log: "Execution log",
      get_children: "Search Children",
      all_items: "All items",
      filter_by: "Filter by:",
      partNumber_status: "PartNumber status",
      is_obsolete: "Obsolete?",
      obsolete_items: "Obsolete items",
      imperfect: "Imperfect",
      list_structure: "List structure:",
      show_related: "Show Related",
      search_bom: "Search BOM",
      obsolete_materials: "Obsolete Materials",
      items_without_bom_link: "Items without BOM link.",
      part_number_not_found: "PN not found",
      material_in_use_by_another_pn: "Material in use by another PN",
      stock_set_aside_for_use: "Set aside for use",
      stock_leftover: "Leftover in pool",
      substituted_by: "Substituted by {pn}",
      semi_finished_of: "semi-finished of",
      semi_finished_short: "semi-finished",
      customer_forecast: "Customer forecast",
      calculation_order: "calculation order {n}",
      net_demand: "Net demand",
      lent_row_label: "lent to",
      lent_out_of_total: "Out of total",
      lent_consumed_as_alternative: "consumed as alternative",
      subtotal_label: "Subtotal",
      total_demand: "Total demand",
      total_in_stock: "Total in stock",
      total_in_transit_label: "Total in transit",
      committed_qty: "{qty} committed",
      available_qty: "{qty} available",
      backlog_previous_week_hint: "shortfall from previous week",
      lent_to_bom: "{pn} lent {qty} to {bom}",
      lent_not_in_total: "Lent material is not part of the total",
      net_demand_per_bom: "Net demand per BOM",
      backlog_previous_week: "Previous week backlog",
      committed: "Committed",
      what_is_being_used: "What is being used",
      analysis_filter_label: "Analysis",
      results_based_on_analysis: "Results based on analysis:",
      analysis_description_template:
        "Forecast Analysis from {{date}}, with {{period}} weeks projection and {{boms}} BOMs.",
      materials_analysis_description_template:
        "Results based on analysis {{id}}, customer {{customer}}, Forecast {{date}}, {{period}} weeks projection and {{boms}} BOMs.",
      view_analysis: "View analysis",
      help: "Help",
      user_manual: "User Manual",
      technical_documentation: "Technical documentation",
      technical_documentation_error: "Error opening technical documentation. Please try again.",
      technical_documentation_popup_blocked:
        "The browser blocked the new tab. Click to open the",
      help_lead:
        "This manual describes, from the end-user perspective, how to operate the PlanMat system — including access, menu modules, main workflows and frequently asked questions.",
      help_summary: "Table of contents",
      wait_for_analysis_completion: "Awaiting analysis completion.",

      help_table_term: "Term",
      help_table_meaning: "Meaning",
      help_table_environment: "Environment",
      help_table_url: "URL",
      help_table_item: "Item",
      help_table_icon: "Icon",
      help_table_route: "Route",
      help_table_function: "Purpose",

      help_s1_title: "1. Introduction",
      help_s1_1_title: "1.1 What is PlanMat",
      help_s1_1_p1:
        "PlanMat (Plan-Mat) is a material planning system aimed at manufacturing environments. It allows you to:",
      help_s1_1_li1: "Manage the product structure (BOM — Bill of Materials).",
      help_s1_1_li2: "Keep records of customers, stock, purchase orders and demand forecasts.",
      help_s1_1_li3:
        "Run availability analyses (GDS) that cross forecast, current stock, in-transit items and BOM to project inventory over time.",
      help_s1_1_li4: "Import data from spreadsheets or directly from SAP.",
      help_s1_1_li5:
        "Export the analysis results to Excel spreadsheets to share with purchasing and production teams.",
      help_s1_2_title: "1.2 Who is this system for",
      help_s1_2_li1:
        "<strong>Material planners</strong> — handle day-to-day: run analyses, check demands, adjust parameters.",
      help_s1_2_li2: "<strong>Buyers</strong> — consume the results to trigger suppliers.",
      help_s1_2_li3: "<strong>Managers</strong> — follow up via the dashboard.",
      help_s1_2_li4:
        "<strong>Administrators</strong> — create users, groups and define permissions.",
      help_s1_3_title: "1.3 Quick glossary",
      help_s1_3_term1: "BOM",
      help_s1_3_def1: "Bill of Materials — list of components that make up a final product.",
      help_s1_3_term2: "GDS",
      help_s1_3_def2: "Availability calculation that projects stock vs. demand over time.",
      help_s1_3_term3: "Forecast",
      help_s1_3_def3: "Demand forecast by customer / component / date.",
      help_s1_3_term4: "Phantom",
      help_s1_3_def4:
        'BOM "phantom" component — has no stock of its own, resolved through its children.',
      help_s1_3_term5: "Alternative item",
      help_s1_3_def5: "Component that can replace another in the same BOM position.",
      help_s1_3_term6: "PO",
      help_s1_3_def6: "Purchase Order — order with in-transit items.",
      help_s1_3_term7: "On hand",
      help_s1_3_def7: "Quantity physically in stock today.",
      help_s1_3_term8: "In transit",
      help_s1_3_def8: "Quantity already purchased but not yet received.",
      help_s1_3_term9: "Projected inventory",
      help_s1_3_def9: "Stock projected for a future date (balance after demand and arrivals).",

      help_s2_title: "2. System access",
      help_s2_1_title: "2.1 Access URL",
      help_s2_1_env1: "Development",
      help_s2_1_url1: "http://10.0.2.125/",
      help_s2_1_env2: "Staging",
      help_s2_1_url2: "https://planmat.fpf.br",
      help_s2_1_env3: "Production",
      help_s2_1_url3: "https://singapura.fxnbr.com",
      help_s2_1_env4: "Local (devs)",
      help_s2_1_url4: "http://localhost:3000",
      help_s2_2_title: "2.2 Login",
      help_s2_2_step1: "Access the URL of the desired environment.",
      help_s2_2_step2: "Fill in <strong>Username</strong> and <strong>Password</strong>.",
      help_s2_2_step3:
        "Use the <strong>PT / EN</strong> selector at the bottom of the login card if you want to change the interface language.",
      help_s2_2_step4: "Click <strong>Sign in</strong>.",
      help_s2_2_note:
        "If credentials are wrong, the system shows a message below the <strong>Sign in</strong> button. Forgot your password? Ask an administrator to reset it via <em>Access control → Users</em>.",
      help_s2_2_alt: "Login screen",
      help_s2_2_caption: "PlanMat login screen.",
      help_s2_3_title: "2.3 Home screen",
      help_s2_3_p1:
        "After logging in, the user is taken to the home screen. The default layout has:",
      help_s2_3_li1: "<strong>Sidebar</strong> on the left, with the navigation menu.",
      help_s2_3_li2:
        "<strong>Top bar</strong> with the logged user indicator, language toggle and logout.",
      help_s2_3_li3: "<strong>Central area</strong> with the content of the current page.",
      help_s2_3_alt: "Home screen",
      help_s2_3_caption: "Home screen after login.",

      help_s3_title: "3. Sidebar menu",
      help_s3_p1: "The sidebar is divided into two main groups:",
      help_s3_alt: "Sidebar menu",
      help_s3_caption: "Expanded sidebar with both groups.",
      help_s3_1_title: "3.1 Access control",
      help_s3_1_item1: "Groups",
      help_s3_1_icon1: "Groups",
      help_s3_1_route1: "/account/group",
      help_s3_1_func1: "Defines access profiles and permissions.",
      help_s3_1_item2: "Users",
      help_s3_1_icon2: "Person",
      help_s3_1_route2: "/account/user",
      help_s3_1_func2: "Registers and manages system users.",
      help_s3_2_title: "3.2 General",
      help_s3_2_item1: "Analysis",
      help_s3_2_icon1: "AutoGraph",
      help_s3_2_route1: "/general/analysis",
      help_s3_2_func1: "Creates, processes and queries GDS analyses.",
      help_s3_2_item2: "BOM",
      help_s3_2_icon2: "DeviceHub",
      help_s3_2_route2: "/general/bom",
      help_s3_2_func2: "Registers the product structure.",
      help_s3_2_item3: "Customer",
      help_s3_2_icon3: "Person",
      help_s3_2_route3: "/general/customer",
      help_s3_2_func3: "Registers customers.",
      help_s3_2_item4: "Stock",
      help_s3_2_icon4: "Warehouse",
      help_s3_2_route4: "/general/stock",
      help_s3_2_func4: "Queries current stock.",
      help_s3_2_item5: "Forecast",
      help_s3_2_icon5: "CalendarMonth",
      help_s3_2_route5: "/general/forecast",
      help_s3_2_func5: "Manages demand forecasts.",
      help_s3_2_item6: "Purchase Order",
      help_s3_2_icon6: "ShoppingCart",
      help_s3_2_route6: "/general/po",
      help_s3_2_func6: "Queries and manages POs.",
      help_s3_2_item7: "Import Data",
      help_s3_2_icon7: "UploadFile",
      help_s3_2_route7: "/general/import-data",
      help_s3_2_func7: "Imports data from spreadsheets or SAP.",
      help_s3_2_item8: "Dashboard",
      help_s3_2_icon8: "Widgets",
      help_s3_2_route8: "/general/dashboard",
      help_s3_2_func8: "Monitoring panels.",
      help_s3_2_item9: "Materials Demands",
      help_s3_2_icon9: "Inventory2",
      help_s3_2_route9: "/general/materials-demands",
      help_s3_2_func9: "Consolidated demands.",
      help_s3_2_item10: "Help",
      help_s3_2_icon10: "HelpOutline",
      help_s3_2_route10: "/general/help",
      help_s3_2_func10: "This user manual.",

      help_s4_title: "4. Access control",
      help_s4_1_title: "4.1 Users — /account/user",
      help_s4_1_p1:
        "Shows the list of registered users, with filters and search. Typical columns are <em>Login, Name, E-mail, Group, Status</em> (active/inactive) and actions (edit/deactivate).",
      help_s4_1_alt1: "User list",
      help_s4_1_caption1: "List of registered users.",
      help_s4_1_p2: "To create or edit:",
      help_s4_1_step1:
        "Click <strong>New user</strong> or double click on the user row you want to edit.",
      help_s4_1_step2:
        "Fill in <em>Login, Name, E-mail, Password</em> (on creation) and select the <em>Permission group</em>.",
      help_s4_1_step3: "Save.",
      help_s4_1_alt2: "User form",
      help_s4_1_caption2: "Create/edit user form.",
      help_s4_1_note:
        "<strong>Password reset:</strong> there is no self-service password change. When the user forgets the password, the administrator opens the user editor (double click on the row) and resets it to the default password <code>123456</code>, which the user must change at the next login. Only users with administrator permission can see this module.",
      help_s4_2_title: "4.2 Groups — /account/group",
      help_s4_2_p1:
        "Shows existing groups (profiles) and how many users each one has. Lets you name the group and tick which menu items / features it can access.",
      help_s4_2_alt1: "Group list",
      help_s4_2_caption1: "List of permission groups.",
      help_s4_2_alt2: "Group form",
      help_s4_2_caption2: "Group editing with allowed menus selection.",

      help_s5_title: "5. Basic records",
      help_s5_1_title: "5.1 Customers — /general/customer",
      help_s5_1_p1: "Simple customer registry used as reference for the forecast.",
      help_s5_1_li1: "<strong>List:</strong> see existing customers, filter by name.",
      help_s5_1_li2:
        "<strong>New customer:</strong> the <em>New</em> button opens the form, usually with the <em>Name</em> field (the system also accepts the default customer <em>SAP Data</em> for forecasts coming from the ERP).",
      help_s5_1_li3: "<strong>Edit / deactivate:</strong> actions on the list row itself.",
      help_s5_1_alt: "Customer list",
      help_s5_1_caption: "List of registered customers.",
      help_s5_2_title: "5.2 BOM — /general/bom",
      help_s5_2_p1: "Registers the structure of each final product.",
      help_s5_2_step1: "Access <strong>BOM</strong> from the menu.",
      help_s5_2_step2: "Click <strong>New BOM</strong> to create a new structure.",
      help_s5_2_step3:
        "Select the <em>Final product</em> (component flagged as <code>is_final_product</code>).",
      help_s5_2_step4:
        "Add the component lines: <em>Component (part number), Required quantity, Item (grouping number), Group, Usage priority</em> (<code>PRIMARY</code> or <code>ALTERNATIVE</code>) and <em>Phantom</em>.",
      help_s5_2_alt1: "BOM list",
      help_s5_2_caption1: "List of registered BOMs.",
      help_s5_2_alt2: "BOM editing",
      help_s5_2_caption2: "BOM editing screen with components.",
      help_s5_2_note:
        'Components flagged as <strong>Phantom</strong> do not generate demand of their own — their demand is "exploded" to the BOM children.',
      help_s5_3_title: "5.3 Stock — /general/stock",
      help_s5_3_p1:
        "Query screen for the current stock (<em>on hand</em>) per component. Data here usually comes through imports (SAP or spreadsheet) and is not edited manually.",
      help_s5_3_alt: "Stock",
      help_s5_3_caption: "Current stock query.",

      help_s6_title: "6. Forecast — /general/forecast",
      help_s6_1_title: "6.1 List forecasts",
      help_s6_1_p1:
        "The module home screen shows existing forecasts, grouped by customer and version (each new import creates a new version).",
      help_s6_1_alt: "Forecast list",
      help_s6_1_caption: "Forecast list by customer and version.",
      help_s6_2_title: "6.2 Detail a forecast",
      help_s6_2_p1:
        "By clicking a forecast, the user sees the forecasted components with quantity and delivery date.",
      help_s6_2_alt: "Forecast detail",
      help_s6_2_caption: "Detail of a forecast.",
      help_s6_3_title: "6.3 Automatic import (SAP)",
      help_s6_3_note:
        "Every Monday at 09:00, the system automatically imports the forecast from SAP (plant 451N by default), creates a new version and triggers the configured analyses. No user action is required.",
      help_s6_3_p1: "To force a manual import, go to <em>Import Data → SAP</em> (see Section 8).",

      help_s7_title: "7. Purchase Orders (PO) — /general/po",
      help_s7_p1:
        "Shows the POs registered in the system with their in-transit components. Each PO line carries: PO number, supplier, component, ordered and converted quantity, estimated time of delivery (ETD) and unit.",
      help_s7_alt: "PO list",
      help_s7_caption: "List of purchase orders with in-transit items.",
      help_s7_note:
        "The in-transit quantity in the analysis calculations comes from these POs (sum of pending quantities with ETD within the analyzed window).",

      help_s8_title: "8. Import data — /general/import-data",
      help_s8_p1:
        "The main screen lists the supported import types and the status of the last executions.",
      help_s8_alt: "Import data",
      help_s8_caption: "Data import hub.",
      help_s8_1_title: "8.1 Spreadsheet import — /general/import-spreadsheets",
      help_s8_1_step1: "Select the data type (Forecast, Stock, BOM, PO, etc.).",
      help_s8_1_step2: "Download the spreadsheet template if it is your first time.",
      help_s8_1_step3:
        "Fill in the spreadsheet and drag the <code>.xlsx</code> file to the upload area (or click <em>Select file</em>).",
      help_s8_1_step4: "Click <strong>Import</strong>.",
      help_s8_1_step5:
        "Follow the status — on error, download the error report generated by the system.",
      help_s8_1_alt: "Spreadsheet import",
      help_s8_1_caption: "Spreadsheet import screen.",
      help_s8_2_title: "8.2 SAP import — /general/import-sap",
      help_s8_2_step1:
        "Make sure the environment has <code>SAP_ENABLED=true</code> (configured by the administrator).",
      help_s8_2_step2: "Select the type (<em>Forecast, Stock</em>, etc.).",
      help_s8_2_step3: 'Enter <em>Plant</em> and <em>Materials</em> (or leave blank for "all").',
      help_s8_2_step4: "Click <strong>Import from SAP</strong>.",
      help_s8_2_step5:
        "The system triggers the <code>imports_worker</code> worker (with VPN) and shows the progress.",
      help_s8_2_alt: "SAP import",
      help_s8_2_caption: "SAP import screen.",
      help_s8_2_note:
        "VPN/SAP connection failures show as an error on this screen. Warn the infrastructure team with the execution ID.",

      help_s9_title: "9. Analysis (GDS) — /general/analysis",
      help_s9_p1: "This is the main flow of the system.",
      help_s9_1_title: "9.1 List analyses",
      help_s9_1_p1:
        "The module home screen shows all analyses (calculated and pending), with name, period (<code>start_date → end_date</code>), status and actions.",
      help_s9_1_alt: "Analysis list",
      help_s9_1_caption: "List of analyses.",
      help_s9_1_note:
        "<strong>Delete analyses:</strong> tick one or more rows using the first-column checkbox and click <em>Delete</em> to remove them permanently. Deletion is multiple by default — select all analyses you wish to delete before confirming.",
      help_s9_2_title: "9.2 Create a new analysis",
      help_s9_2_step1: "Click <strong>New analysis</strong>.",
      help_s9_2_step2:
        "Fill in <em>Analysis name</em> (suggestion: date + customer, e.g., <code>2026-05_FPF</code>), <em>Start date</em> and <em>End date</em> of the horizon, and the <em>Considered forecasts</em> (one or more — multi-select).",
      help_s9_2_step3: "Click <strong>Save</strong>. The analysis enters the queue for processing.",
      help_s9_2_alt: "New analysis",
      help_s9_2_caption: "Analysis creation form.",
      help_s9_3_title: "9.3 Track the processing",
      help_s9_3_p1:
        "Shows the calculation progress in real time. Communication via WebSocket, updating progress bar, current step (loading BOMs, calculating demand, generating results, exporting) and estimated completion.",
      help_s9_3_alt: "Analysis processing",
      help_s9_3_caption: "Real-time processing screen.",
      help_s9_4_title: "9.4 Error screen",
      help_s9_4_p1:
        'When the calculation fails, it shows the cause and the components/POs/forecasts that triggered the error, with a correction hint (e.g., "BOM not found for product X").',
      help_s9_4_alt: "Analysis errors",
      help_s9_4_caption: "Error detail screen.",
      help_s9_5_title: "9.5 GDS calculation",
      help_s9_5_p1: "After processing, it shows for each component:",
      help_s9_5_li1: "Initial stock (<code>on_hand</code>)",
      help_s9_5_li2: "Projected demand (from the forecast)",
      help_s9_5_li3: "In-transit quantities (from POs)",
      help_s9_5_li4: "Projected stock by date (<code>projected_inventory</code>)",
      help_s9_5_li5: "Status (sufficient / risk / shortage)",
      help_s9_5_alt: "GDS calculation",
      help_s9_5_caption: "GDS calculation screen per component.",
      help_s9_6_title: "9.6 GDS simulation",
      help_s9_6_p1:
        "Lets you change parameters (stock quantity, early arrival of PO, replacement by alternative item, etc.) and see the impact on the projected stock <strong>without persisting the change</strong>.",
      help_s9_6_alt: "GDS simulation",
      help_s9_6_caption: "GDS simulation screen.",
      help_s9_7_title: "9.7 Export result",
      help_s9_7_p1:
        "From the calculation screen, click <strong>Export</strong> (upper right corner) to generate the result in Excel. The generation is asynchronous: the system triggers a worker and the file becomes available for download once it is ready. The file is stored on the server for a configurable period and can be downloaded again from the history.",

      help_s10_title: "10. Materials Demands — /general/materials-demands",
      help_s10_p1:
        'Consolidates in a single screen the total component demand for a given interval, summing all active analyses. Useful for purchasing to quickly check "what needs to be bought".',
      help_s10_p2: "Typical features:",
      help_s10_li1: "Filter by period and component.",
      help_s10_li2: "Export to Excel.",
      help_s10_li3:
        "Drill-down: by clicking the component you see which analyses contribute to the demand.",
      help_s10_alt: "Materials Demands",
      help_s10_caption: "Materials Demands screen.",

      help_s11_title: "11. Dashboard — /general/dashboard",
      help_s11_p1: "Management monitoring panel with:",
      help_s11_li1: "<strong>KPI cards at the top:</strong>",
      help_s11_li2: "<em>Critical coverage</em> — items with up to 4 weeks of coverage.",
      help_s11_li3: "<em>Attention coverage</em> — items with 5 to 8 weeks of coverage.",
      help_s11_li4: "<em>Material surplus</em> — items with surplus after full coverage.",
      help_s11_li5: "<em>Obsolete materials</em> — items without BOM links.",
      help_s11_li6:
        "<strong>Continuous forecast and outlier detection (95% CI)</strong> — main area. Use the <em>Filter by</em> filter (Part Number / Model) and pick a value so the forecast chart is displayed.",
      help_s11_li7:
        "<strong>Side cards:</strong> long-term forecast, deviations/anomalies and general demand trend.",
      help_s11_alt: "Dashboard",
      help_s11_caption: "Management monitoring panel.",

      help_s12_title: "12. Frequently asked questions (FAQ)",
      help_s12_q1: "Q: Why is my analysis taking so long?",
      help_s12_a1:
        "Analyses with many components and long windows take more time. The system uses dedicated Celery workers (<code>analysis-worker-1</code> and <code>analysis-worker-2</code>) that process one analysis at a time per worker. If there is a queue, your analysis waits for the previous one to finish.",
      help_s12_q2: "Q: I imported the spreadsheet but some components do not appear.",
      help_s12_a2:
        "Inactive components (<code>active=false</code>) do not enter the analyses. Also check whether the <code>part_number</code> in the spreadsheet exists exactly as registered.",
      help_s12_q3: 'Q: The SAP import is stuck on "VPN".',
      help_s12_a3:
        "VPN is required to access the SAP network. If the VPN credential has expired or the TOTP is out of sync, the import fails. Contact the infrastructure team.",
      help_s12_q4: 'Q: What is a "phantom component"?',
      help_s12_a4:
        'Phantom is a BOM component without its own stock. When the analysis finds a phantom, it "explodes" the demand to the child components.',
      help_s12_q5: "Q: Can I reopen an old analysis?",
      help_s12_a5:
        "Yes. Every analysis is stored with its result (<code>AnalysisResult</code>). Go to <em>Analysis</em>, click the name and use <em>View calculation</em> or <em>Export</em> again.",
      help_s12_q6: "Q: How do I delete an analysis I no longer need?",
      help_s12_a6:
        "In the <em>Analysis</em> list, tick the row(s) using the first-column checkbox and click <em>Delete</em>. The operation accepts multiple selection.",
      help_s12_q7: "Q: How do I change my password?",
      help_s12_a7:
        "There is no self-service password change. Ask an administrator to edit your user in <em>Access control → Users</em> (double click on the row) and reset to the default password <code>123456</code>. Change the password after your first login.",

      help_s13_title: "13. Support",
      help_s13_li1: "<strong>Support channel:</strong> to be defined (e-mail / chat).",
      help_s13_li2: "<strong>Response SLA:</strong> to be defined.",
      help_s13_li3:
        "<strong>How to open a ticket:</strong> describe the error step by step, environment (dev/staging/prod), user name, analysis/import ID and attach a screenshot.",

      bom_models: "BOM (Models)",
      select_bom_to_view_components: "Select a BOM above to view and edit the components.",
      not_informed: "Not informed",
      add_substitute: "→ add substitute",
      successfully_added_substitute: "Substitute successfully added",
      successfully_updated_substitute: "Substitute successfully updated",
      substitution_already_exists: "This component already has a registered substitute.",
      invalid_substitution_data: "Invalid data to add the substitute.",
      substitute: "Substitute",
      new_part_number: "New Part Number",
      starting_from: "starting from",
      search_part_number_description_substitute: "Part Number, description, substitute",
      substitute_quantity_must_be_positive: "Quantity must be greater than zero",
      reset_simulation: "Reset simulation",
      reset_simulation_confirm_message:
        "Are you sure you want to remove all substitutes and manually added PNs from this BOM model?",
      successfully_reset_simulation: "Simulation reset successfully",
      add_above: "Add above",
      add_below: "Add below",
      add_subitem: "Add subitem",
      exclude: "Delete",
      deactivate: "Deactivate",
      activate: "Activate",
      manually_added: "Manually added",
      new_pn_part_number: "New item Part Number",
      invalid_addition_data: "Invalid data to add the new PN.",
      part_number_required: "Please enter the Part Number.",
      successfully_added_pn: "New PN added successfully",
      successfully_updated_pn: "PN updated successfully",
      successfully_deleted_pn: "PN removed successfully",
      successfully_toggled_pn: "PN status updated successfully",
      delete_pn_confirm_title: "Delete added PN",
      delete_pn_confirm_message:
        "Are you sure you want to delete this manually added PN? To keep it in the structure without considering it in the calculation, use 'Deactivate'.",
      sap_import_health: "SAP import health",
      sap_import_health_subtitle: "Track the result of the most recent execution of the loads used in planning.",
      sap_import_health_load_error: "Could not load SAP import health.",
      price_per_pn: "Price per PN",
      last_execution: "Last execution",
      view_details: "View details",
      no_execution_recorded: "No execution recorded",
      import_started_at: "Started at",
      not_available: "Not available",
      in_progress_label: "In progress",
      try_again: "Try again",
      import_status_healthy: "Healthy",
      import_status_critical: "Critical",
      import_status_processing: "Processing",
      import_status_not_run: "Not run",
      import_result_success: "Load completed successfully.",
      import_result_error: "The last load finished with an error.",
      import_result_processing: "Load in progress.",
      import_result_not_run: "No execution has been recorded.",
      materialStatus: {
        tabs: {
          gds: "GDS Result",
          demands: "Items and Demand",
          materialStatus: "Material Status",
          waitForCompletionTooltip: "Wait for analysis completion to access this tab.",
          notGeneratedTooltip:
            "This analysis does not have a Material Status generated yet. Complete the GDS calculation and click Generate Material Status.",
          loadingAnalysis: "Loading analysis...",
        },
        loading: {
          gds: "Loading GDS result",
          demands: "Loading items and demand",
          grid: "Loading grid",
        },
        kpi: {
          pnInFilter: "P/N in filter",
          redBeacon: "Red beacon",
          withShortage: "With shortage in horizon",
          closestShortage: "Closest shortage",
          redBeaconUnavailable: "Not available: PlanMat holds no RAG",
        },
        controls: {
          searchPlaceholder: "P/N or limiting component",
          searchAriaLabel: "Search Part Number...",
          onlyShortage: "Shortage only",
          onlyShortageAriaLabel: "Shortage only",
          exportXlsx: "Export Excel",
          exporting: "Exporting...",
          waiting: "Waiting...",
          exportError: "Could not export Material Status. Try again.",
          exportExpired: "The export expired. Generate it again.",
          horizon: "Horizon",
          weeksOption: "{{count}} wks",
          collapseAll: "Collapse all",
          expandAll: "Expand all",
          fullscreen: "Full screen",
          exitFullscreen: "Exit full screen",
          fullscreenEnterTooltip: "View grid only, full screen",
          fullscreenExitTooltip: "Exit full screen (Esc)",
        },
        legend: {
          summaryTitle: "Color legend and calculation notes",
          dsiCriticalLabel: "Critical",
          dsiCriticalDesc: "DSI below 5 days",
          dsiShortLabel: "Short",
          dsiShortDesc: "DSI from 5 to 9 days",
          dsiAdequateLabel: "Adequate",
          dsiAdequateDesc: "DSI from 10 to 15 days",
          dsiComfortableLabel: "Comfortable",
          dsiComfortableDesc: "DSI above 15 days",
          noteTotalSupplyTitle: "Total supply",
          noteTotalSupplyBody: "adds Finish Goods / WIP and Material On Hands in the week they are recorded. Material in transit, ETA and",
          notePoPendingEmp: "PO pending ODM commitment",
          notePoPendingRest: "have no source in PlanMat yet.",
          noteProjectedStockTitle: "Projected inventory",
          noteProjectedStockBody:
            "starts at zero in the baseline week; each week takes the previous balance, deducts the net forecast and adds the supply available in that same week.",
          noteDsiTitle: "DSI",
          noteDsiBody:
            "divides projected inventory by the average daily demand of the next 4 weeks (20 working days), rounded away from zero. Without demand in those weeks it is left empty.",
          sourceSap: "Source: frozen snapshot of the analysis (Forecast Net, Finish Goods / WIP and Material On Hands)",
        },
        grid: {
          partNumber: "PN ({{count}})",
          limitingComponent: "Limiting\ncomponent",
          priority: "Priority",
          pnPerPage: "P/N per page",
          pageRange: "{{start}} – {{end}} of {{total}}",
          fromSnapshot: "from the frozen snapshot",
          unavailable: "no data in PlanMat",
          calculated: "calculated",
          shortageFrom: "Shortage from {{week}}",
          noShortage: "No shortage in the horizon",
          openTrace: "Calculation memory: {{row}}, {{pn}}, {{week}}",
          openOnHand: "Material On Hands: {{pn}}, {{week}}",
        },
        descriptions: {
          forecastNet:
            "Planned customer consumption per week from the Forecast module. Demands draw down stock.",
          forecastFlex:
            "Net forecast plus contractual flexibility and safety buffer. Used as conservative demand scenario.",
          finishGoods:
            "Assembled boards or in-progress factory WIP from the Inventory module.",
          onHands:
            "Counted physical warehouse inventory at baseline week from the Inventory module.",
          inTransit:
            "Shipped inventory in transit via air/ocean from purchase orders, grouped by arrival week.",
          eta: "Supplier-committed departures (ETD) with estimated arrival (ETA) from purchase orders.",
          poPending:
            "Purchase orders pending supplier commit. Not counted in total supply or projected stock.",
          total:
            "Finish Goods / WIP plus Material On Hands, in the week they are recorded. Material in transit, ETA and POs have no source in PlanMat yet and are not added.",
          projNet:
            "Projected weekly inventory balance. Negative values denote stock shortage.",
          projFlex:
            "Projected weekly inventory balance considering flex forecast and safety buffer.",
          dsi: "Days Sales Inventory: days of production covered based on next 4 weeks demand.",
        },
        trace: {
          title: "Calculation memory",
          loading: "Loading calculation memory",
          error: "Could not load the calculation memory of this cell.",
          close: "Close",
          projectionTitle: "Projected inventory",
          previousBalance: "Previous balance ({{week}})",
          baselineStart: "Baseline: balance starts at 0",
          demand: "− Forecast Net of the week",
          finishedGoods: "+ Finish Goods / WIP",
          materialOnHand: "+ Material On Hands",
          totalSupply: "= Total supply of the week",
          projected: "Projected inventory ({{week}})",
          shortageOf: "Shortage of {{quantity}} kits",
          dsiTitle: "DSI",
          windowWeek: "Forecast Net {{week}}",
          windowTotal: "Demand of the next 4 weeks",
          dailyAverage: "Daily average (÷ {{days}} working days)",
          rawValue: "Projected inventory ÷ daily average",
          dsiValue: "DSI (rounded away from zero)",
          partialWindow: "End of the horizon: the window only has the weeks that exist.",
          noFutureDemand: "No future demand: DSI is not calculated.",
          beforeBaseline: "Week before the baseline: not calculated.",
          range: {
            critical: "Critical",
            short: "Short",
            adequate: "Adequate",
            comfortable: "Comfortable",
          },
          shortageTitle: "Shortage and recovery",
          firstShortage: "First shortage",
          noShortage: "No shortage in the horizon",
          recovery: "Recovery",
          recoveryIn: "{{week}} (in {{count}} weeks)",
          noRecovery: "No recovery in the horizon",
          limitingComponent: "Material On Hands / limiting component",
        },
        onHand: {
          title: "Material On Hands - {{pn}}",
          summaryKits: "{{kits}} kits to produce",
          summaryStock: "{{kits}} kits in stock",
          summaryScenario: "by net forecast",
          summaryStockBasis: "from physical warehouse stock",
          tableSectionTitle: "Part numbers in shortage this week",
          tableSectionTitleStock: "BOM components and stock coverage",
          noShortage: "No part numbers in shortage this week.",
          partNumberCol: "Part number",
          usageCol: "Usage",
          requiredCol: "Required",
          availableCol: "Available",
          missingCol: "Shortage",
          coverageCol: "Coverage",
          limitingBadge: "Limiting",
          footerCoverage: "Coverage of",
          footerKitsMissing: "kits - missing",
          footerRestrictedBy: ", restricted by",
          footerKitsStock: "kits in stock",
          footerRestrictedByStock: ", restricted by",
          footerAllCoverPrefix: "All components cover the",
          footerAllCoverSuffix: "kits.",
          footerShortage: "Coverage of {{- coverage}} kits - missing {{- missing}}, restricted by {{limiting}}.",
          footerStockOnly: "Coverage of {{- coverage}} kits in stock, restricted by {{limiting}}.",
          footerNoShortage: "All components cover the {{- kits}} kits.",
          noBreakdown: "Component breakdown is not available for this Material Status snapshot.",
          loading: "Loading Material On Hands details...",
          error: "Could not load the Material On Hands details for this cell.",
          closeAriaLabel: "Close",
        },
        empty: "No Part Numbers found for the selected filters.",
        loadError: "Could not load Material Status data for this analysis.",
      },
    },
  },
};

export { messages };
